import React from 'react';
import Link from 'next/link';
import { prepareLink } from '@utils/dataHelpers';
import Preloader from '@components/Preloader';
import { Employer, CompanyName, Industry, Logo, PreloaderContainer } from '@components/EmployerBox/styles';

interface EmployerBoxProps {
  employer: Employer;
  loading: boolean;
}

function EmployerBox({ employer, loading }: EmployerBoxProps) {
  return (
    <Link key={employer.id} href={prepareLink('employer', employer.slug, employer.id)} passHref>
      <Employer href={prepareLink('employer', employer.slug, employer.id)}>
        {loading ? (
          <PreloaderContainer>
            <Preloader />
          </PreloaderContainer>
        ) : (
          <>
            <Logo>
              <img src={employer.logo.desktop} alt={employer.name} />
            </Logo>

            <CompanyName>{employer.name}</CompanyName>
            <Industry>{employer.fieldOfExpertise}</Industry>
          </>
        )}
      </Employer>
    </Link>
  );
}

export default EmployerBox;
